import * as colorPalette from '../palette';

// GS Color palette
export const gsGreen700 = '#4D774E';
export const gsGreen600 = '#9ac69d';
export const gsGreen500 = '#9DC88D';
export const gsGreen400 = '#AAC1A1';
export const gsGreen300 = '#DAE5D5';
export const gsGreen200 = '#E9F4E4';
export const gsGreen100 = '#F1F7EF';
export const gsOrange700 = '#DC8B06';
export const gsOrange500 = '#F1B24A';
export const gsOrange400 = '#F7C67F';
export const gsOrange300 = '#F5C77A';
export const gsOrange200 = '#F9D89C';
export const gsGray800 = '#333333';
export const gsGray600 = '#4F4F4F';
export const gsGray500 = '#828282';
export const gsGray400 = '#BDBDBD';
export const gsGray300 = '#E0E0E0';
export const gsGray200 = '#FBFCFD';

export const pageBackground = gsGreen100;
export const pageBackgroundTopLeft = gsGreen500;
export const pageBackgroundBottomRight = gsGreen100;
export const pageBackgroundLineTop = colorPalette.white;
export const pageBackgroundLineMid = gsGreen300;
export const pageBackgroundLineBottom = gsGreen500;
export const pageText = gsGray600;
export const pageTextLight = gsGray500;
export const pageTextSubdued = gsGray400;
export const pageTextDark = gsGray800;
export const pageTextPositive = gsOrange500;
export const pageTextLink = colorPalette.blue600;
export const pageTextLinkLight = colorPalette.blue300;

export const cardBackground = colorPalette.white;
export const cardBorder = gsOrange500;
export const cardShadow = colorPalette.navy700;

export const tableBackground = colorPalette.white;
export const tableRowBackgroundHover = gsGreen200;
export const tableText = pageText;
export const tableTextLight = pageTextLight;
export const tableTextSubdued = pageTextSubdued;
export const tableTextSelected = colorPalette.navy700;
export const tableTextHover = colorPalette.navy900;
export const tableTextInactive = gsGray400;
export const tableHeaderText = colorPalette.navy600;
export const tableHeaderBackground = colorPalette.white;
export const tableBorder = colorPalette.navy100;
export const tableBorderSelected = gsOrange500;
export const tableBorderHover = gsOrange500;
export const tableBorderSeparator = colorPalette.navy400;
export const tableRowBackgroundHighlight = gsGreen100;
export const tableRowBackgroundHighlightText = gsGreen500;
export const tableRowHeaderBackground = gsGreen200;
export const tableRowHeaderText = colorPalette.navy800;
export const tableRowHeaderAlternativeBackground = gsGreen300;
export const tableRowHeaderAlternativeText = gsGreen700;

export const sidebarBackground = gsGray200;
export const sidebarItemBackgroundPending = gsOrange700;
export const sidebarItemBackgroundPositive = colorPalette.green500;
export const sidebarItemBackgroundFailed = colorPalette.red300;
export const sidebarItemBackgroundHover = gsGreen200;
export const sidebarItemAccentSelected = gsOrange700;
export const sidebarItemText = gsGreen700;
export const sidebarItemTextSelected = gsOrange700;
export const sidebarItemTextNegative = colorPalette.red700;
export const accountBalanceNegativeBackground = colorPalette.red100;

export const menuBackground = colorPalette.white;
export const menuItemBackground = colorPalette.navy50;
export const menuItemBackgroundHover = colorPalette.navy100;
export const menuItemText = gsGreen700;
export const menuItemTextHover = menuItemText;
export const menuItemTextSelected = gsOrange500;
export const menuItemTextHeader = colorPalette.navy400;
export const menuBorder = colorPalette.navy100;
export const menuBorderHover = gsOrange500;
export const menuKeybindingText = colorPalette.navy400;
export const menuAutoCompleteBackground = gsGreen700;
export const menuAutoCompleteBackgroundHover = gsGreen500;
export const menuAutoCompleteText = colorPalette.white;
export const menuAutoCompleteTextHover = colorPalette.green150;
export const menuAutoCompleteTextHeader = gsOrange500;
export const menuAutoCompleteItemTextHover = menuAutoCompleteText;
export const menuAutoCompleteItemText = menuAutoCompleteText;

export const modalBackground = colorPalette.white;
export const modalBorder = colorPalette.white;
export const mobileHeaderBackground = gsGreen400;
export const mobileHeaderText = gsGray800;
export const mobileHeaderTextSubdued = colorPalette.gray200;
export const mobileHeaderTextHover = 'rgba(200, 200, 200, .15)';
export const mobilePageBackground = colorPalette.navy50;
export const mobileNavBackground = colorPalette.white;
export const mobileNavItem = colorPalette.gray300;
export const mobileNavItemSelected = gsOrange500;
export const mobileAccountShadow = colorPalette.navy300;
export const mobileAccountText = colorPalette.blue800;

// Mobile view themes (for the top bar)
export const mobileViewTheme = mobileHeaderBackground;
export const mobileConfigServerViewTheme = colorPalette.purple500;

export const markdownNormal = colorPalette.purple150;
export const markdownDark = colorPalette.purple400;
export const markdownLight = colorPalette.purple100;

// Button
export const buttonMenuText = colorPalette.navy100;
export const buttonMenuTextHover = colorPalette.navy50;
export const buttonMenuBackground = 'transparent';
export const buttonMenuBackgroundHover = 'rgba(200, 200, 200, .25)';
export const buttonMenuBorder = gsGreen500;
export const buttonMenuSelectedText = colorPalette.green800;
export const buttonMenuSelectedTextHover = colorPalette.orange800;
export const buttonMenuSelectedBackground = colorPalette.orange200;
export const buttonMenuSelectedBackgroundHover = colorPalette.orange300;
export const buttonMenuSelectedBorder = buttonMenuSelectedBackground;

export const buttonPrimaryText = colorPalette.white;
export const buttonPrimaryTextHover = buttonPrimaryText;
export const buttonPrimaryBackground = gsGreen700;
export const buttonPrimaryBackgroundHover = gsGreen500;
export const buttonPrimaryBorder = buttonPrimaryBackground;
export const buttonPrimaryShadow = 'rgba(0, 0, 0, 0.3)';
export const buttonPrimaryDisabledText = colorPalette.white;
export const buttonPrimaryDisabledBackground = gsGreen400;
export const buttonPrimaryDisabledBorder = buttonPrimaryDisabledBackground;

export const buttonNormalText = gsGreen700;
export const buttonNormalTextHover = buttonNormalText;
export const buttonNormalBackground = colorPalette.white;
export const buttonNormalBackgroundHover = buttonNormalBackground;
export const buttonNormalBorder = gsGreen700;
export const buttonNormalShadow = 'rgba(0, 0, 0, 0.2)';
export const buttonNormalSelectedText = colorPalette.white;
export const buttonNormalSelectedBackground = colorPalette.blue600;
export const buttonNormalDisabledText = gsGreen400;
export const buttonNormalDisabledBackground = buttonNormalBackground;
export const buttonNormalDisabledBorder = gsGreen400;

export const calendarText = gsOrange500;
export const calendarBackground = gsGray200;
export const calendarItemText = gsGray600;
export const calendarItemBackground = gsGreen200;
export const calendarSelectedBackground = gsGreen500;

export const buttonBareText = buttonNormalText;
export const buttonBareTextHover = buttonNormalText;
export const buttonBareBackground = 'transparent';
export const buttonBareBackgroundHover = 'rgba(100, 100, 100, .15)';
export const buttonBareBackgroundActive = 'rgba(100, 100, 100, .25)';
export const buttonBareDisabledText = buttonNormalDisabledText;
export const buttonBareDisabledBackground = buttonBareBackground;

export const noticeBackground = colorPalette.green150;
export const noticeBackgroundLight = colorPalette.green100;
export const noticeBackgroundDark = colorPalette.green500;
export const noticeText = colorPalette.green700;
export const noticeTextLight = colorPalette.green500;
export const noticeTextDark = colorPalette.green900;
export const noticeTextMenu = gsGreen200;
export const noticeBorder = colorPalette.green500;
export const warningBackground = colorPalette.orange200;
export const warningText = colorPalette.orange700;
export const warningTextLight = colorPalette.orange500;
export const warningTextDark = colorPalette.orange900;
export const warningBorder = colorPalette.orange500;
export const errorBackground = colorPalette.red100;
export const errorText = colorPalette.red500;
export const errorTextDark = colorPalette.red700;
export const errorTextDarker = colorPalette.red900;
export const errorTextMenu = colorPalette.red200;
export const errorBorder = colorPalette.red500;
export const upcomingBackground = colorPalette.purple100;
export const upcomingText = colorPalette.purple700;
export const upcomingBorder = colorPalette.purple500;

export const formLabelText = colorPalette.blue600;
export const formLabelBackground = colorPalette.blue200;
export const formInputBackground = colorPalette.navy50;
export const formInputBackgroundSelected = colorPalette.white;
export const formInputBackgroundSelection = colorPalette.purple500;
export const formInputBorder = colorPalette.navy150;
export const formInputTextReadOnlySelection = colorPalette.navy50;
export const formInputBorderSelected = gsOrange500;
export const formInputText = colorPalette.navy900;
export const formInputTextSelected = colorPalette.navy50;
export const formInputTextPlaceholder = colorPalette.navy300;
export const formInputTextPlaceholderSelected = colorPalette.navy200;
export const formInputTextSelection = colorPalette.navy100;
export const formInputShadowSelected = gsOrange500;
export const formInputTextHighlight = gsOrange700;
export const checkboxText = tableBackground;
export const checkboxBackgroundSelected = gsGreen500;
export const checkboxBorderSelected = gsGreen500;
export const checkboxShadowSelected = gsGreen500;
export const checkboxToggleBackground = colorPalette.gray400;

export const pillBackground = gsGreen200;
export const pillBackgroundLight = colorPalette.white;
export const pillText = colorPalette.navy800;
export const pillTextHighlighted = gsOrange500;
export const pillBorder = gsGreen700;
export const pillBorderDark = colorPalette.navy300;
export const pillBackgroundSelected = gsGreen200;
export const pillTextSelected = colorPalette.blue900;
export const pillBorderSelected = gsOrange500;
export const pillTextSubdued = colorPalette.navy200;

export const reportsRed = colorPalette.red300;
export const reportsBlue = colorPalette.blue400;
export const reportsGreen = colorPalette.green400;
export const reportsLabel = colorPalette.navy900;
export const reportsInnerLabel = colorPalette.navy800;

export const headerBackground = gsGreen300;
